
// src/store/modules/account.js
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import {
    API_RESETPWD_INFO,
    APP_RESETPWD_FAILURE
} from '../../../config/mutation-types'

import {
    API_AI
} from '../../../config/const'


const state = {
    apiInfo: ''
}

const getters = {
    resetPwd: state => state.apiInfo
}

const actions = {
    resetPwd({commit}, options) {
        var uri = API_AI + "/h5/auth/modifyLoginPasswordByPhoneCode"
        if(options.data.from && options.data.redirect){
            uri += '?from=' + options.data.from + '&redirect=' + options.data.redirect
        }
        return new Promise((resolve, reject) => {
            Vue.http.post(uri,{
                mobile: options.data.mobile,
                validationCode: options.data.validationCode,
                newPassword: options.data.newPassword
            }).then((res, err) => {
                    resolve(res.data)
                }, (res) => {
                    reject(res.data)
                })
            }).then((res) => {
                commit(API_RESETPWD_INFO, res)
            }, (err) => {
                commit(APP_RESETPWD_FAILURE, err + '获取信息失败')
            })
    }
}

const mutations = {
    [API_RESETPWD_INFO](state, data) {
        state.apiInfo = data
    },
    [APP_RESETPWD_FAILURE](state, data) {
        state.apiInfo = data
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/login/resetPwd.js